<template>
  <fin-time-and-tags :tag="showTag ? value.category.id : null"
                     :datetime="value.datePublished"
                     :datetimePrepend="value.source.id + ' - '"
                     class="mb-1"
  />
</template>

<script>

export default {
  name: 'fin-news-item-source-date-category',
  props: {
    value: {
      type: Object
    },
    showTag: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style lang="scss" scoped>

  .news-item__category {
    font-size: 0.9em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    background-color: $fin-color-pale-grey;
    border: solid 1px $fin-color-light-blue-gray;
    border-radius: 0;
    padding: 2px 8px;
  }

  .news-item__source-date {
    font-size: 0.9em;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: 1px;
    color: $fin-color-cool-grey;
    display: inline-block;
  }

</style>
